module.exports = __webpack_public_path__ + "img/RORBPJR40028.6222cd9d.png";